import type { FaqItem } from '../types/content'
import { siteConfig } from './siteConfig'

// Le domande con risposta vuota non vengono mostrate.
export const faqs: FaqItem[] = [
  {
    question: 'Bisogna saper disegnare?',
    answer:
      'No. Posizioni un modello stampato sotto il supporto trasparente e ne segui le linee: è il modello a guidare il tuo tratto.',
  },
  {
    question: 'È adatto a chi è alle prime armi?',
    answer:
      'Sì. Il percorso inizia dalla scelta dei materiali e da esercizi semplici, prima dei primi progetti guidati.',
  },
  {
    question: 'Cosa contiene il kit?',
    answer:
      'Sei risorse digitali: la guida L’Atelier delle Vetrate Creative, Scegliere bene i materiali, I miei modelli da ricalcare, Le mie prime creazioni, Il mio quaderno dei colori e 100+ modelli per l’effetto vetrata.',
  },
  {
    question:
      'Che differenza c’è tra i modelli per esercitarsi e i 100+ modelli?',
    answer:
      'I modelli da ricalcare servono per esercitarti con linee, curve e contorni. La raccolta di oltre 100 modelli ti offre poi un’ampia scelta di motivi per le tue creazioni.',
  },
  {
    question: 'Ciascuno dei 100+ modelli include un tutorial?',
    answer:
      'No. Il kit comprende una raccolta di modelli da ricalcare e, separatamente, sei progetti guidati passo dopo passo in Le mie prime creazioni.',
  },
  {
    question: 'I materiali sono inclusi?',
    answer:
      'No. È un prodotto digitale: colori, contorni, supporti e strumenti vanno procurati a parte. La guida Scegliere bene i materiali ti aiuta a selezionarli.',
  },
  {
    question: 'Bisogna tagliare o saldare il vetro?',
    answer:
      'No. La tecnica insegnata consiste nel tracciare contorni e dipingere su un supporto trasparente adatto. Non serve tagliare né saldare nulla.',
  },
  {
    question: 'Devo stampare tutti i documenti?',
    answer:
      'No. Le guide si possono consultare sullo schermo; stampi solo i modelli che scegli di realizzare.',
  },
  {
    question: 'Come ricevo i file?',
    answer: siteConfig.deliveryAnswer,
  },
  {
    question: 'Posso vendere le mie creazioni?',
    answer: siteConfig.commercialUseAnswer,
  },
]
